module.exports = __webpack_public_path__ + "static/img/luan.16706a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/luan.svg
// module id = ygJR
// module chunks = 0